import { ComparePageObjectModel } from '@/poms/comparePageObjectModel';
import { Box, styled } from '@mui/material';
import { useMemo } from 'react';
import { CollapsibleLines } from './CollapsibleLines';
import { renderLineText } from './renderLineText';
import { buildUnifiedLines, TextDiffRow, UnifiedDiffLine } from './textDiffRows';
import { DiffText, LineNumber } from './textDiffStyles';

const UnifiedGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'min-content min-content minmax(0, 1fr)',
});

const isUnchangedLine = (line: UnifiedDiffLine) => line.kind === 'unchanged';

const getLineKey = (line: UnifiedDiffLine) => `${line.leftLineNumber ?? '-'}:${line.rightLineNumber ?? '-'}`;

const renderLine = (line: UnifiedDiffLine) => (
  <>
    <LineNumber data-kind={line.kind}>{line.leftLineNumber}</LineNumber>
    <LineNumber data-kind={line.kind}>{line.rightLineNumber}</LineNumber>
    <DiffText data-kind={line.kind}>{renderLineText(line)}</DiffText>
  </>
);

export const UnifiedDiffView = ({ rows }: { rows: TextDiffRow[] }) => {
  const lines = useMemo(() => buildUnifiedLines(rows), [rows]);

  return (
    <UnifiedGrid data-testid={ComparePageObjectModel.TextDiffUnifiedView}>
      <CollapsibleLines lines={lines} isUnchanged={isUnchangedLine} getKey={getLineKey} renderLine={renderLine} />
    </UnifiedGrid>
  );
};
